import { ElectronApi } from '@/services/electron.api';

export type LibName =
  | 'dssim'
  | 'pngquant'
  | 'ezip'
  | 'imgutils'
  | 'ffmpeg'
  | 'fontClip'
  | 'LVGLImage';
export const remoteLibsConfig: {
  libName: LibName;
  autoDownload?: boolean;
  libs: {
    url: string;
    paltform: 'darwin' | 'win32';
    version: number;
  }[];
}[] = [
  {
    libName: 'dssim',
    autoDownload: true,
    libs: [
      {
        url: 'https://cdn.cnbj1.fds.api.mi-img.com/watchface-editor-release/libs/darwin/dssim',
        version: 1,
        paltform: 'darwin'
      },
      {
        url: 'https://cdn.cnbj1.fds.api.mi-img.com/watchface-editor-release/libs/win32/dssim.exe',
        version: 1,
        paltform: 'win32'
      }
    ]
  },
  {
    libName: 'pngquant',
    autoDownload: true,
    libs: [
      {
        url: 'https://cdn.cnbj1.fds.api.mi-img.com/watchface-editor-release/libs/darwin/pngquant',
        version: 1,
        paltform: 'darwin'
      },
      {
        url: 'https://cdn.cnbj1.fds.api.mi-img.com/watchface-editor-release/libs/win32/pngquant.exe',
        version: 1,
        paltform: 'win32'
      }
    ]
  },
  {
    libName: 'ezip',
    autoDownload: ElectronApi.versionType() != 'normal',
    libs: [
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/darwin/ezip_mac',
        version: 2,
        paltform: 'darwin'
      },
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/win32/ezip.exe',
        version: 1,
        paltform: 'win32'
      }
    ]
  },
  {
    libName: 'fontClip',
    autoDownload: ElectronApi.versionType() != 'normal',
    libs: [
      {
        url: 'https://cdn.cnbj1.fds.api.mi-img.com/watchface-editor-release/libs/darwin/clip-font',
        version: 1,
        paltform: 'darwin'
      },
      {
        url: 'https://cdn.cnbj1.fds.api.mi-img.com/watchface-editor-release/libs/win32/clip-font.exe',
        version: 1,
        paltform: 'win32'
      }
    ]
  },
  {
    libName: 'imgutils',
    autoDownload: true,
    libs: [
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/darwin/imgutils',
        version: 6,
        paltform: 'darwin'
      },
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/win32/imgutils.exe',
        version: 6,
        paltform: 'win32'
      }
    ]
  },
  {
    libName: 'ffmpeg',
    autoDownload: false,
    libs: [
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/darwin/ffmpeg',
        version: 5,
        paltform: 'darwin'
      },
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/win32/ffmpeg.exe',
        version: 5,
        paltform: 'win32'
      }
    ]
  },
  {
    libName: 'LVGLImage',
    autoDownload: true,
    libs: [
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/darwin/LVGLImage',
        version: 2,
        paltform: 'darwin'
      },
      {
        url: 'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/libs/win32/LVGLImage.exe',
        version: 2,
        paltform: 'win32'
      }
    ]
  }
];
